<template>
  <v-layout column>
    <vbt-search
      v-model="searchData"
      :items="searchFieldsConfig"
      @reset="onResetSearch"
      @search="onSearch"
    />

    <vbt-content-box
      :loading="isLoading"
      :loading-error="loadingError"
      :no-content="noContent"
      :go-back-btn="goBack"
      title="Information"
    >
      <template #toolbar>
        <v-btn
          small
          color="success"
          @click="openEditorDialog()"
        >
          Create product
        </v-btn>
      </template>
      <vbt-table
        :items="products"
        :headers="headers"
        show-edit-action
        @click:edit="openEditorDialog"
      >
        <template #state="{ item: { state } }">
          <kernel-status-badge :status="productStatusEnumByValue[state]">
            {{ state }}
          </kernel-status-badge>
        </template>
        <template #flags="{ item: { flags } }">
          {{ (flags || []).join(', ') }}
        </template>
      </vbt-table>

      <vbt-pagination
        v-model="pageNum"
        :items-count="pagedItemsCount"
        :total-count="productsTotalCount"
      />
    </vbt-content-box>

    <kernel-product-editor
      v-model="editorDialog"
      :creator="isEditorCreateMode"
      :item="editableProduct"
      @success="$_fetchData"
    />
  </v-layout>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';

import {
  useEditorWithDialog,
  useDataLoading,
  usePagination,
  useSearch,
} from '@mixins/factories';

import { namespace as EnumsNamespace } from '@store/modules/enums.types';
import { namespace as LocationsNamespace } from '@store/modules/locations.types';

import { namespace as ProductsNamespace, ActionTypes as ProductsActionTypes } from '../store.types';

import KernelProductEditor from '../_components/KernelProductEditor.vue';

const dataLoadingOptions = { getterName: ProductsActionTypes.GET_PRODUCTS, contentName: 'products' };
const paginationOptions = { contentName: 'products' };
const searchOptions = {
  initialSearchDataStates: [
    'state', 'name',
  ],
};

const headers = Object.freeze([
  { text: 'Name', value: 'name' },
  { text: 'Abbreviation', value: 'abbreviation' },
  { text: 'State', value: 'state' },
  { text: 'Flags', value: 'flags' },
]);

export default {
  name: 'KernelProducts',
  components: {
    KernelProductEditor,
  },
  mixins: [
    useEditorWithDialog({ editableItemName: 'editableProduct' }),
    useDataLoading(dataLoadingOptions),
    usePagination(paginationOptions),
    useSearch(searchOptions),
  ],
  data: () => ({ headers }),
  computed: {
    ...mapState(ProductsNamespace, ['products', 'productsTotalCount']),
    ...mapState(LocationsNamespace, ['suffix']),
    ...mapState(EnumsNamespace, {
      productStatuses: ({ enums: { productStatus: enums } }) => (enums || [])
        .map(({ value }) => value),
    }),
    ...mapGetters(EnumsNamespace, ['productStatusEnumByValue']),
    searchFieldsConfig() {
      return [
        { value: 'name', label: 'Name', type: 'text' },
        {
          value: 'state',
          items: this.productStatuses,
          label: 'State',
          type: 'select',
        },
      ];
    },
  },
  watch: {
    suffix: '$_refreshData',
  },
  methods: {
    ...mapActions(ProductsNamespace, [ProductsActionTypes.GET_PRODUCTS]),
  },
};
</script>
